import request from '../utils/request'
// 获取商品详情
export function productDetail (data) {
  return request({
    url: '/api/app/merchant/product/product_detail',
    method: 'get',
    params: data
  })
}
// 详情规格
export function productSpecDetail (data) {
  return request({
    url: '/api/app/merchant/product/product_spec_detail',
    method: 'get',
    params: data
  })
}
// 活动信息
export function promotionNameSearch (data) {
  return request({
    url: 'api/app/merchant/product/promotion_name_search',
    method: 'get',
    params: data
  })
}
// 物品数量
export function upAndDown (data) {
  return request({
    url: 'api/app/ordercart/up_and_down',
    method: 'post',
    data: data
  })
}
// 加入常购
export function insertMchInfoFrequentPurchase (data) {
  return request({
    url: 'api/app/merchant/mchinfo/insertMchInfoFrequentPurchase',
    method: 'post',
    data: data
  })
}

// 搜索接口
export function productSearchList (data) {
  return request({
    url: '/api/app/merchant/product/product_search_list',
    method: 'get',
    params: data
  })
}

// 获取全部分类接口
export function queryCategoryList () {
  return request({
    url: '/api/app/merchant/product/query_category_list',
    method: 'get'
  })
}

// 通过分类获取商品
export function categoryProductList (data) {
  return request({
    url: '/api/app/merchant/product/category_product_list',
    method: 'get',
    params: data
  })
}
